export const createVerb = (verb) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    const firestore = getFirestore();
    firestore
      .collection('verbs')
      .add({
        ...verb,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'CREATE_PROJECT_ERROR' }, err);
      });
  };
};

export const updateVerb = (verb, id) => {
  // alert(id);
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection('verbs')
      .doc(id)
      .update({
        Language1: verb.Language1,
        Language2: verb.Language2,
        PresentParticiple: verb.PresentParticiple,
        PastParticiple: verb.PastParticiple,
        Present: verb.Present,
        Past: verb.Past,
        Past1: verb.Past1,
        Conditional: verb.Conditional,
        Future: verb.Future,
        Imperativ: verb.Imperativ,
        Imperativ1: verb.Imperativ1,
        Description1: verb.Description1,
        Description2: verb.Description2,
      })
      .then(() => {
        dispatch({ type: 'UPDATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'UPDATE_PROJECT_ERROR' }, err);
      });
  };
};

export const createWord = (word, table_name) => {
  console.log(word);
  console.log(table_name);
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    const firestore = getFirestore();
    firestore
      //.collection("word_set")
      .collection(table_name)
      .add({
        ...word,
        level: 1,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'CREATE_PROJECT_ERROR' }, err);
      });
  };
};

export const updateWord = (word, table) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    //  alert(word.id);
    const firestore = getFirestore();
    firestore
      .collection(table)
      .doc(word.id)
      .update({
        Language1: word.Language1,
        Language2: word.Language2,
        Language3: word.Language3,
        Language4: word.Language4,
        Language5: word.Language5,
        Description1: word.Description1,
        Description2: word.Description2,
        Description3: word.Description3,
        Description4: word.Description4,
        Description5: word.Description5,
        set: word.set,
      })
      .then(() => {
        dispatch({ type: 'UPDATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'UPDATE_PROJECT_ERROR' }, err);
      });
  };
};

//Right:"Language2",Left:"Language2",Up:"Language1",Down:"Language2",SpanishVoice:"",GermanVoice:"",EnglishVoice:"",FrenchVoice:"",X:"Description1",Y:"Description2
export const updateUserSettings = (settings, uid) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    // alert(settings.Speed);
    const firestore = getFirestore();
    firestore
      .collection('user_settings')
      .doc(uid)
      .update({
        Right: settings.Right,
        Left: settings.Left,
        Up: settings.Up,
        Down: settings.Down,
        SpanishVoice: settings.SpanishVoice,
        GermanVoice: settings.GermanVoice,
        EnglishVoice: settings.EnglishVoice,
        FrenchVoice: settings.FrenchVoice,
        ItalianVoice: settings.ItalianVoice,
        X: settings.X,
        Y: settings.Y,
        A: settings.A,
        B: settings.B,
        Start: settings.Start,
        Select: settings.Select,
        Speed: settings.Speed,
      })
      .then(() => {
        dispatch({ type: 'UPDATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'UPDATE_PROJECT_ERROR' }, err);
      });
  };
};

export const changeDates = (selected, table) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    selected.map((b) => {
      firestore.collection(table).doc(b).update({
        createdAt: new Date(),
      });
    });
  };
};

export const changeLevels = (selected, value, table) => {
  // alert(table);
  // alert(selected);
  // alert(value);
  //.collection("word_set")
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    selected.map((b) => {
      firestore.collection(table).doc(b).update({
        level: value,
      });
    });
  };
};

export const fieldUpdate = (selected, value, table, field) => {
  // alert(table);
  // alert(selected);
  //  alert(value+field);
  //.collection("word_set")
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    selected.map((b) => {
      firestore
        .collection(table)
        .doc(b)
        .update({
          [field]: value,
        });
    });
  };
};

export const changeSets = (selected, value) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    //     alert("innn");
    const firestore = getFirestore();

    selected.map((b) => {
      firestore.collection('word_set').doc(b).update({
        set: value,
      });
    });
  };
};

export const bookmarVerb = (id, value) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    //     alert("innn");
    const firestore = getFirestore();

    firestore.collection('verbs').doc(id).update({
      bookmarked: value,
    });
  };
};

export const bookmarkWords = (selected, value, collection) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    //     alert("innn");
    const firestore = getFirestore();

    selected.map((b) => {
      firestore.collection(collection).doc(b).update({
        bookmarked: value,
      });
    });
  };
};

export const deleteWords = (selected, collection) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    //     alert("innn");
    const firestore = getFirestore();

    selected.map((b) => {
      firestore.collection(collection).doc(b).delete();
    });
  };
};

export const createWordsCSV = (word) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    const firestore = getFirestore();
    firestore
      .collection('word_set')
      .add({
        ...word,
        level: 1,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
      })
      .catch((err) => {
        dispatch({ type: 'CREATE_PROJECT_ERROR' }, err);
      });
  };
};

export const createCSVWords = (words) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    const firestore = getFirestore();

    words.map((word) => {
      firestore.collection('word_temp').add({
        ...word,
        createdAt: new Date(),
      });
    });
  };
};
